import { useEffect, useState } from "react"

type ShareChannel = string

import Toast from "@/components/Toast"
import { i18n } from "@/i18n"

import {
    downloadIcon,
    linkIcon,
    xIcon,
    facebookIcon,
} from "@/assets/imgs/share/index"

interface UseSharePlatformsProps {
    uid?: string
    nickname?: string
    code?: string
    shareImageSrc?: string
    shareImageRef?: React.RefObject<HTMLImageElement>
    download: () => void
    isRecall: boolean
}

export const EVENT_NAME_MAP = {
    SHARE_CLICK: "social_media_share",
    LOTTERY: "lottery",
    FIRST_WATCH_TUTORIAL: "first_watch_tutorial_initial",
    GAME_START: "mini_game_start",
    GAME_END: "mini_game_end",
    GAME_STAGE: "mini_game_stage",
}

// const getLocalSharePlatforms = () => [
//     {
//         key: "weibo" as ShareChannel,
//         icon: weiboIcon,
//         title: i18n.get("shareModal.platforms.weibo"),
//     },
//     {
//         key: "qzone" as ShareChannel,
//         icon: qzoneIcon,
//         title: i18n.get("shareModal.platforms.qzone"),
//     },
//     {
//         key: "qq" as ShareChannel,
//         icon: qqIcon,
//         title: i18n.get("shareModal.platforms.qq"),
//     },
//     {
//         key: "copy" as ShareChannel,
//         icon: linkIcon,
//         title: i18n.get("shareModal.platforms.copy"),
//     },
//     {
//         key: "link-in-skland" as ShareChannel,
//         icon: linkIcon,
//         title: i18n.get("shareModal.platforms.copy"),
//     },
//     {
//         key: "download" as any,
//         icon: downloadIcon,
//         title: i18n.get("shareModal.platforms.download"),
//     },
// ]

export default function useSharePlatforms({
    uid,
    code,
    shareImageSrc,
    shareImageRef,
    download,
    isRecall,
}: UseSharePlatformsProps) {
    const [platforms, setPlatforms] = useState<
        {
            key: string
            icon: string
            title: string
        }[]
    >([])

    const [hasShared, setHasShared] = useState<boolean>(false)

    // biome-ignore lint/correctness/useExhaustiveDependencies: <遗留代码>
    useEffect(() => {
        setPlatforms([
            {
                key: "x",
                icon: xIcon,
                title: i18n.get("shareModal.platforms.x"),
            },
            {
                key: "facebook",
                icon: facebookIcon,
                title: i18n.get("shareModal.platforms.facebook"),
            },
            {
                key: "download",
                icon: downloadIcon,
                title: i18n.get("shareModal.platforms.download"),
            },
            {
                key: "copy",
                icon: linkIcon,
                title: i18n.get("shareModal.platforms.copy"),
            },
        ])
    }, [shareImageSrc])

    const onClickPlatform = (key: ShareChannel | string) => {
        setHasShared(true)

        if (String(key) === "download") {
            download()
            return
        }

        if (key === "x") {
            const text =
                "Arknights special web-event: Wang's Weiqi Challenge\nhttps://wangsweiqichallenge.arknights.global/\n#Arknights #WangsWeiqiChallenge #Yostar"
            window.open(
                `https://x.com/intent/tweet?text=${encodeURIComponent(text)}`,
                "_blank",
                "noopener,noreferrer",
            )
            return
        }

        if (key === "facebook") {
            const url = location.origin + location.pathname
            window.open(
                `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                    url,
                )}`,
                "_blank",
                "noopener,noreferrer",
            )
            return
        }

        if (key === "copy") {
            const url = location.origin + location.pathname
            navigator.clipboard
                .writeText(url)
                .then(() => {
                    Toast.message(i18n.get("msg.copySuccess"))
                })
                .catch(() => {
                    Toast.message(i18n.get("shareModal.messages.copyFailed"))
                })
        }
    }

    return { platforms, onClickPlatform, hasShared }
}
